module.exports = "//static.hsappstatic.net/WebsiteGraderUI/static-1.1473/img/favicon.png"


//////////////////
// WEBPACK FOOTER
// ../node_modules/bender-webpack/lib/bender-url-loader.js!./img/favicon.png
// module id = 73
// module chunks = 0 1